const {required} = require("@common/react/cs-form/validators/required");

exports.lineChartFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
    },
};
